<template>
    <v-content>
        <ContentToolbar v-if="$route.meta.showContentToolbar"/>
        <v-layout row wrap pa-0 ma-0>
            <v-flex xs12>
                <ContentHeader v-if="$route.meta.showContentHeader"></ContentHeader>
            </v-flex>
            <v-flex xs12>
                <router-view class="page-container"/>
            </v-flex>
        </v-layout>
        <ContentFooter v-if="$route.meta.showContentFooter"/>
    </v-content>
</template>

<script>
    import {mapGetters, mapState,} from "vuex";
    import ContentToolbar from "@/pages/Layout/ContentToolbar";
    import ContentHeader from "@/pages/Layout/ContentHeader";
    import ContentFooter from "@/pages/Layout/ContentFooter";

    export default {
        name: "AppContent",
        components: {
            ContentToolbar,
            ContentHeader,
            ContentFooter,
        },
        computed: {
            ...mapGetters("UserState", {
                    isSettingsOpened: "isSettingsOpened",
                }
            ),
        },
    };
</script>

<style lang="scss" scoped>
</style>

